import { Button, Modal } from 'antd';
import React from 'react';

const BasicModal = ({
    visible,
    onOk,
    onCancel,
    loading,
    children,
    objectName,
    isEditing,
    title,
    hiddenTile,
    width,
    top = 40,
    formId,
    bodyStyle,
    maskClosable,
    noFooter,
    emptyFooter,
    additionalButton,
    className,
    closable = true,
    centered,
    disabledSubmit,
    okText = 'Lưu',
    cancelText = 'Đóng',
}) => {
    const getTitle = () => {
        if (hiddenTile) return null;
        if (title) return title;
        const name = (objectName || '').toUpperCase();
        return isEditing ? `CẬP NHẬT ${name}` : `THÊM MỚI ${name}`;
    };

    const formSubmitId = formId || `form-${objectName}`;

    // 1. FOOTER BUTTONS
    const footerButtons = [
        <Button
            key="back"
            onClick={onCancel}
            style={{
                borderRadius: 2,
                height: 32,
                padding: '4px 15px',
            }}
        >
            {cancelText}
        </Button>,
    ];

    if (onOk) {
        footerButtons.push(
            <Button
                key="submit"
                htmlType="submit"
                type="primary"
                loading={loading}
                form={formSubmitId}
                disabled={disabledSubmit}
                style={{
                    borderRadius: 2,
                    height: 32,
                    padding: '4px 15px',
                    backgroundColor: '#1890ff',
                    borderColor: '#1890ff',
                    marginLeft: 8,
                }}
            >
                {okText}
            </Button>,
        );
    }

    if (additionalButton) {
        footerButtons.push(additionalButton);
    }

    // 2. STYLES RÕ RÀNG CHO 3 PHẦN: HEADER, BODY, FOOTER
    const modalStyles = {
        // Container chính của Modal
        content: {
            padding: 0,
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },

        // --- PHẦN 1: HEADER ---
        header: {
            padding: '16px 24px',
            margin: 0,
            borderBottom: '1px solid #f0f0f0',
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '22px',
            color: '#262626',
        },

        // --- PHẦN 2: BODY ---
        body: bodyStyle || {
            padding: '24px',
            maxHeight: 'calc(-40px + 78vh)',
            overflowY: 'auto',
            overflowX: 'hidden',
        },

        // --- PHẦN 3: FOOTER ---
        footer: {
            padding: '10px 16px',
            margin: 0,
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
    };

    return (
        <Modal
            open={visible}
            title={getTitle()}
            onOk={onOk}
            onCancel={onCancel}
            footer={noFooter ? null : emptyFooter ? [] : footerButtons}
            width={width || 800}
            style={top === null ? undefined : { top }}
            centered={centered}
            closable={closable}
            maskClosable={!!maskClosable}
            destroyOnClose
            className={className}
            styles={modalStyles}
        >
            {children && React.cloneElement(children, { formId: formSubmitId, onSubmit: onOk })}
        </Modal>
    );
};

export default BasicModal;